import { sortBy } from "lodash";

import { CHART_COLORS } from "app/constants/ChartColors";
import type { ChannelCanonical, ChannelDescriptions, ChannelKeyName } from "app/constants/MmxChannels";
import type { ApiOvertimeData } from "app/pages/industry-analysis/traffic-sources/MarketingChannels/TrafficShareBarChart/types";
import dateTimeService from "app/services/date-time/dateTimeService";
import { trafficSourcesForSegments } from "app/Shared/utils";

import type { IServices } from "../../common/useMarketingChannelsServices";
import type { IChartData } from "../TrafficVolumesLineChart.types";

export const adaptApiData = (data: ApiOvertimeData, services: IServices): IChartData[] | null => {
    if (!data) {
        return null;
    }

    const channelNames = Object.keys(data).map((x) => x as ChannelKeyName | ChannelDescriptions | ChannelCanonical);

    return channelNames
        .map((channelName) => {
            const channelRecords = data[channelName];
            if (!channelRecords) return null;
            const trafficSource = trafficSourcesForSegments[channelName];
            if (!trafficSource) return null;
            const color = CHART_COLORS.trafficSourcesColorsBySourceMMX[channelName];
            const adaptedRecords = Object.entries(channelRecords).map(([key, value]) => ({
                x: dateTimeService.getUTCTimeStamp(key),
                y: value,
            }));
            const sortedRecords = sortBy(adaptedRecords, (point) => point.x);

            return {
                name: services.translate(trafficSource.title),
                color: color,
                data: sortedRecords,
                priority: trafficSource.priority,
            };
        })
        .filter((x) => x != null);
};

export const sortChartData = (data: IChartData[]) => {
    if (!data || data.length <= 0) {
        return null;
    }
    return sortBy(data, (record) => record.priority);
};
